<script lang="ts">
	import CardsGridLayout from '@app/components/cards/CardsGridLayout.svelte';
	import CardsSkeleton from './CardsSkeleton.svelte';

	export let numberOfSkeletons: number;
</script>

<CardsGridLayout>
	{#each Array(numberOfSkeletons) as skeleton}
		<CardsSkeleton />
	{/each}
</CardsGridLayout>
